import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import ClearIcon from '@mui/icons-material/Clear';
import "swiper/css";
import "swiper/css/pagination";
import Video1 from "../../Assets/Video/Video1.mp4"
import Video2 from "../../Assets/Video/Video2.mp4"
import Video3 from "../../Assets/Video/Video3.mp4"
import Video4 from "../../Assets/Video/Video4.mp4"
import Video5 from "../../Assets/Video/Video5.MOV"
import Video6 from "../../Assets/Video/Video6.mp4"
import Video7 from "../../Assets/Video/Video7.MOV"
import Video8 from "../../Assets/Video/Video8.mp4"
import Video9 from "../../Assets/Video/Video9.MP4"

import { Box, Modal } from "@mui/material";
import { Pagination, Autoplay } from "swiper";
function PerviewVideoCarusel() {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const data = [
    {
      id: 1,
      img: Video1,
      title: "Internet yo‘qligida amalga oshirilgan to‘lovlar maʼlumotlar bazasida to‘planadi.  Internetga qaytatdan ulanishda ular FMOga yuborilishi kerak! "
    },
    {
      id: 2,
      img: Video2,
      title: "Платежи, совершенные при отсутствии интернета, собираются в базе данных.  При повторном подключении к интернету их необходимо отправить в ОФД!"
    },
    {
      id: 3,
      img: Video3,
      title: "..."
    },
    {
      id: 4,
      img: Video4,
      title: "..."
    },
    {
      id: 5,
      img: Video5,
      title: "..."
    },
    {
      id: 6,
      img: Video6,
      title: "..."
    },
    {
      id: 7,
      img: Video7,
      title: "«Руководство по CashBox»! 🤳🏻Чем оснащена задняя панель онлайн-кассы: ⠀ ▪️Слот для SIM1-карты,  ▪️Слот для карты SAM2/SIM2,  ▪️Слот для карты памяти емкостью до 128 ГБ, ▪️Слот для карты PSAM Фиск Модуль❗️"
    },
    {
      id: 8,
      img: Video8,
      title: "Mahsulotni qo’shish bo’yicha qo’llanma❗️"
    },
    {
      id: 9,
      img: Video9,
      title: "Инструкция по добавлению товара❗️"
    },
  ]
  const [clicedDevObj, setClicedDevObj] = useState(
    {
      id: 1,
      img: "",
      title: ""
    }
  )
  const handleClick = (evt) => {
    setOpen(true)
    setClicedDevObj(data.find(item => (
      item.id === evt.target.id - 0
    )))
  }
  return (
    <>
      <Swiper
        slidesPerView={5}
        spaceBetween={60}
        autoplay={{
          delay: 1000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Pagination]}
        className="mySwiper cursor-pointer"
      >
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video1} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start text-ellipsis max-w-full whitespace-nowrap overflow-hidden">Internet yo‘qligida amalga oshirilgan to‘lovlar maʼlumotlar bazasida to‘planadi.  Internetga qaytatdan ulanishda ular FMOga yuborilishi kerak! </p>
            <button onClick={handleClick} id="1" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video2} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start text-ellipsis max-w-full whitespace-nowrap overflow-hidden">Платежи, совершенные при отсутствии интернета, собираются в базе данных.  При повторном подключении к интернету их необходимо отправить в ОФД! </p>
            <button onClick={handleClick} id="2" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video3} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start ">... </p>
            <button onClick={handleClick} id="3" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video4} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start ">...</p>
            <button onClick={handleClick} id="4" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video5} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start ">...</p>
            <button onClick={handleClick} id="6" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video6} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start ">...</p>
            <button onClick={handleClick} id="6" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video7} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start text-ellipsis max-w-full whitespace-nowrap overflow-hidden">«Руководство по CashBox»! 🤳🏻
              ⠀
              Чем оснащена задняя панель онлайн-кассы:
              ⠀
              ▪️Слот для SIM1-карты,
              ▪️Слот для карты SAM2/SIM2,
              ▪️Слот для карты памяти емкостью до 128 ГБ,
              ▪️Слот для карты PSAM Фиск Модуль❗️

              👆Подробная инструкция</p>
            <button onClick={handleClick} id="7" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video8} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start text-ellipsis max-w-full whitespace-nowrap overflow-hidden">«Руководство по CashBox»! 🤳🏻
              ⠀
              Чем оснащена задняя панель онлайн-кассы:
              ⠀
              ▪️Слот для SIM1-карты,
              ▪️Слот для карты SAM2/SIM2,
              ▪️Слот для карты памяти емкостью до 128 ГБ,
              ▪️Слот для карты PSAM Фиск Модуль❗️

              👆Подробная инструкция</p>
            <button onClick={handleClick} id="8" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="w-full h-full bg-[#6F42C1] rounded-md">
            <video className="rounded-tr-md rounded-tl-md" controls>
              <source src={Video9} type="video/mp4" />
            </video>
            <p className="text-[12px] text-white font-semibold p-1 text-start text-ellipsis max-w-full whitespace-nowrap overflow-hidden">Инструкция по добавлению товара</p>
            <button onClick={handleClick} id="9" className="text-[12px] bg-[#2C1A7E] mt-5 text-white p-2 rounded-2xl" type="button">Узнать больше</button>
          </div>
        </SwiperSlide>
      </Swiper>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={`w-[95%] h-[40%] ${clicedDevObj?.title === "..." ? "md:w-[40%]" : "md:w-[70%]"}  md:h-[70%] mt-[50%] sm:mt-28 flex items-start space-x-1 lg:space-x-10 m-auto  bg-[#6F42C1] rounded-md`}>
          <video className="rounded-tl-md rounded-bl-md w-[50%] h-full" controls>
            <source src={clicedDevObj?.img} type="video/mp4" />
          </video>
          <div className="w-[50%]">
            <p className="text-[13px] md:text-[20px] text-white font-semibold p-2 sm:p-5 ">{clicedDevObj?.title}</p>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default PerviewVideoCarusel